import { mount } from 'svelte'
import './app.css'
import App from './App.svelte'
// Instantiating the store applies the theme class and starts listening for
// system changes; importing it for the side effect is the point.
import './lib/theme.svelte'

const target = document.getElementById('app')
if (!target) throw new Error('#app is missing from index.html')

/**
 * Discard any server-rendered markup before mounting.
 *
 * `scripts/prerender.mjs` injects real HTML into #app so that a crawler
 * without JavaScript — notably an OAuth reviewer fetching the privacy policy
 * — reads the actual text rather than an empty shell. That markup is for
 * them, not for us.
 *
 * We cannot `hydrate()` over it: the prerender renders the PAGE component
 * alone, while the client mounts the whole App shell (nav, outlet, footer),
 * so the two trees do not correspond. Without this line `mount()` APPENDS,
 * and the page renders twice — two <h1>, two <article>, every paragraph
 * duplicated. That is exactly what happened before it was added.
 */
target.innerHTML = ''

export default mount(App, { target })
